// ------------------------------
// Helpers
// ------------------------------
const pad = (v) => String(v).padStart(2, "0");

const formatDate = (d) =>
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

const formatDateTime = (d) =>
    `${formatDate(d)} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(
        d.getSeconds()
    )}`;

const addHours = (d, h) => new Date(d.getTime() + h * 3600 * 1000);

// ------------------------------
// Diagnosis pools
// ------------------------------
const HEALTHY_DIAGNOSIS = [
    "No anomalies detected",
    "Machine operating within normal vibration and temperature limits",
    "Stable vibration signature observed across all axes",
];

const WARNING_DIAGNOSIS = [
    "Velocity vibration marginally high on Shaft_Perpendicular axis; monitor bearing condition.",
    "Temperature marginally above normal threshold; check cooling and ventilation.",
    "Slight increase in vibration velocity detected; recommend continued monitoring.",
    "Shaft perpendicular vibration approaching marginal limit; inspect alignment during next maintenance.",
];

// ------------------------------
// MAIN FUNCTION
// ------------------------------
export const generateVibrationAiAnalysisAllDemo = ({
                                                       meter_id,
                                                       page = 1,
                                                       per_page = 1000,
                                                   }) => {
    const totalDays = 30; // realistic history window
    const items = [];

    let healthyCount = 0;
    let warningCount = 0;
    let criticalCount = 0;

    for (let i = 0; i < totalDays; i++) {
        const baseDate = new Date();
        baseDate.setDate(baseDate.getDate() - i);

        const startTime = addHours(baseDate, 0);
        const endTime = addHours(baseDate, 23.9);

        // Mostly healthy, occasional warning
        const isWarning = i % 5 === 0 || i % 9 === 0;

        const health = isWarning ? "Warning" : "Healthy";
        const diagnosis = isWarning
            ? WARNING_DIAGNOSIS[i % WARNING_DIAGNOSIS.length]
            : HEALTHY_DIAGNOSIS[i % HEALTHY_DIAGNOSIS.length];

        if (health === "Healthy") healthyCount++;
        if (health === "Warning") warningCount++;

        items.push({
            id: 300 - i,
            meter_id: Number(meter_id),
            date: formatDate(baseDate),
            created_at: formatDateTime(addHours(baseDate, 1)),
            acknowledge: i < 2 || i % 6 === 0, // some acknowledged
            comment:
                i === 0
                    ? "Checked – system healthy"
                    : i === 1
                        ? "Reviewed"
                        : null,
            data: {
                start_time: formatDateTime(startTime),
                end_time: formatDateTime(endTime),
                machine_health: health,
                diagnosis,
            },
        });
    }

    return {
        meter_id: Number(meter_id),
        total: items.length,
        items,
        summary: {
            Healthy: healthyCount,
            Warning: warningCount,
            Critical: criticalCount,
        },
    };
};
